








































import { Component, Vue } from "vue-property-decorator";

@Component
export default class MHeader extends Vue {
  private isHamMenu = false;
}
